export default "__VITE_ASSET__8iQbH_r0__"